import { AxiosInstance } from "axios";

export const UserEventService = (axiosInstance: AxiosInstance) => {
  const apiBaseUrl = "api/users";

  return {
    getByEventAndUser: async (eventId: string, ticketid: string) => {
      return await axiosInstance.get(`${apiBaseUrl}/${eventId}/${ticketid}`).then((result) => result.data);
    },
    getByEventAndTicket: async (eventId: string, ticketid: string) => {
      return await axiosInstance.get(`${apiBaseUrl}/${eventId}/ticket/${ticketid}`).then((result) => result.data);
    },
    getByEventAndWristbandid: async (eventId: string, wristbandId: string) => {
      return await axiosInstance.get(`${apiBaseUrl}/${eventId}/wristband/${wristbandId}`).then((result) => result.data);
    },
    createByEvent: async (eventId: string, data: any) => {
      return await axiosInstance.post(`${apiBaseUrl}/${eventId}`, data).then((result) => result.data);
    },
    updateByEvent: async (userId: string, data: any) => {
      return await axiosInstance.patch(`${apiBaseUrl}/agenda/${userId}`, data).then((result) => result.data);
    },
    validateWristbandId: async (agendaId: string, wrisbandId: string) => {
      return await axiosInstance.post(`${apiBaseUrl}/validate-wrisbandid/${agendaId}/${wrisbandId}`).then((result) => result.data.message);
    },
  };
};
